import * as Yup from 'yup'

export default Yup.object().shape({
    plan: Yup.number().required('Selecione um plano!')
})